/* eslint-disable @typescript-eslint/ban-types */
type IsFnHelper<T = unknown> = (value: unknown) => value is T

function isTypeof<T = unknown>(value: unknown, type: string): value is T {
  return typeof value === type
}

export const isFunction = ((value) => isTypeof(value, 'function')) as IsFnHelper<Function>
